// import React, { useEffect, useRef, useState } from 'react'
// import Header from '../Components/Header'
// import '../css/kyc.css'
// import Rightcontainer from '../Components/Rightcontainer'
// import { Link, useHistory } from 'react-router-dom'
// import axios from 'axios'
// import css from '../css/Pan.module.css'
// import Swal from 'sweetalert2'
// import '../css/Loader.css'

// const Kyc2 = ({ user }) => {
//   const history = useHistory()

//   const [frontLoaded, setfrontLoaded] = useState(null)
//   const [backLoaded, setbackLoaded] = useState(null)
//   const [Name, setName] = useState()
//   const [Email, setEmail] = useState()
//   const [Number, setNumber] = useState()
//   const [DOB, setDob] = useState()
//   const [process, setProcess] = useState(false)

//   let aadharProcess = useRef(false)

//   const handleSubmitdata = (e) => {
//     if (user.verified == 'unverified' || user.verified == 'reject') {
//       if (aadharProcess.current === false) {
//         setProcess(true)
//         aadharProcess.current = true
//         e.preventDefault()
//         console.log(frontLoaded, backLoaded)
//         const formData = new FormData()

//         formData.append('Name', Name)
//         formData.append('Email', Email)
//         formData.append('Number', Number)
//         formData.append('DOB', DOB)
//         formData.append('front', frontLoaded)
//         formData.append('back', backLoaded)

//         if (frontLoaded && backLoaded) {
//           const access_token = localStorage.getItem('token')
//           const headers = {
//             Authorization: `Bearer ${access_token}`,
//           }

//           axios
//             .post(`https://api.rrludo.in/aadharcard`, formData, {
//               headers,
//             })
//             .then((res) => {
//               console.log(res.data)
//               if (res.data.status === false) {
//                 Swal.fire({
//                   title: res.data.msg,
//                   icon: 'danger',
//                   confirmButtonText: 'error',
//                 })
//               } else if (res.data.msg === false) {
//                 Swal.fire({
//                   title: 'Duplicate Entity',
//                   icon: 'danger',
//                   confirmButtonText: 'error',
//                 })
//               } else {
//                 Swal.fire({
//                   title: 'You Kyc form submitted',
//                   icon: 'success',
//                   confirmButtonText: 'ok',
//                 })
//                 history.push('/Profile')
//               }
//               // console.log(res.data)
//               //
//               aadharProcess.current = false
//               setProcess(false)
//             })
//             .catch((e) => {
//               console.log(e)
//               if (e.response.status == 401) {
//                 localStorage.removeItem('token')
//                 localStorage.removeItem('token')
//                 window.location.reload()
//                 history.push('/login')
//               }
//             })
//         } else {
//           aadharProcess.current = false
//           setProcess(false)
//           alert('please fill all field')
//         }
//       } else {
//         alert('You have submited request already.')
//       }
//     } else {
//       alert('You request in Process.')
//     }
//   }
//   useEffect(() => {
//     console.log(user)
//     let access_token = localStorage.getItem('token')
//     access_token = localStorage.getItem('token')
//     if (!access_token) {
//       window.location.reload()
//       history.push('/login')
//     }
//     const frontPhoto = document.getElementById('frontPhoto')
//     frontPhoto.onchange = (e) => {
//       const [file] = frontPhoto.files
//       setfrontLoaded(file)
//     }
//     const backPhoto = document.getElementById('backPhoto')
//     backPhoto.onchange = (e) => {
//       const [file] = backPhoto.files
//       setbackLoaded(file)
//     }
//   }, [])
//   return (
//     <div>
//       <div className="leftContainer">
//         <div className="kycPage mt-5 py-4 px-3">
//           {/* <p className="mt-2" style={{ color: 'rgb(149, 149, 149)' }}>
//             You need to submit a document that shows that you are{' '}
//             <span style={{ fontWeight: 500 }}>above 18 years</span> of age and
//             not a resident of{' '}
//             <span style={{ fontWeight: 500 }}>
//               Assam, Odisha, Sikkim, Nagaland, Telangana, Andhra Pradesh, Tamil
//               Nadu and Karnataka.
//             </span>
//           </p> */}
//           {/* <br /> */}
//           {/* <div>
//             <span style={{ fontSize: "1.5em" }}>Step 2</span> of 3
//           </div> */}
//           <p className="mt-2" style={{ color: 'rgb(149, 149, 149)' }}>
//             Enter details of Aadhar Card:{' '}
//             {/* <span style={{ fontWeight: 500 }}>098765432212</span> */}
//           </p>
//           {/* <br /> */}
//           <form onSubmit={handleSubmitdata}>
//             <div style={{ marginTop: '10px' }}>
//               <div className="kyc-doc-input">
//                 <div className="label">First Name</div>
//                 <input
//                   type="text"
//                   name="Name"
//                   placeholder="Enter name"
//                   value={Name}
//                   onChange={(e) => setName(e.target.value)}
//                   required
//                 />
//               </div>
//               {/* <br /> */}
//               <div className="kyc-doc-input mt-4">
//                 <div className="label">Email Id</div>
//                 <input
//                   type="text"
//                   name="Email"
//                   placeholder="Email Id"
//                   value={Email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   required
//                 />
//               </div>
//                <div className="kyc-doc-input mt-4">
//                 <div className="label">Date of Birth</div>
//                 <input
//                   type="date"
//                   name="Name"
//                   placeholder="enter name"
//                   value={DOB}
//                   onChange={(e) => setDob(e.target.value)}
//                   required
//                 />
//               </div>
//               <div className="kyc-doc-input mt-4">
//                 <div className="label">Aadhar Number</div>
//                 <input
//                   type="tel"
//                   name="Name"
//                   placeholder=" Aadhar Number"
//                   onChange={(e) => setNumber(e.target.value)}
//                   required
//                 />
//               </div> 
//               <div className={`${css.doc_upload} mt-4`}>
//                 <input
//                   id="frontPhoto"
//                   name="frontPhoto"
//                   type="file"
//                   accept="image/*"
//                   required
//                 />
//                 {!frontLoaded && (
//                   <div className="cxy flex-column position-absolute ">
//                     <img
//                       src="/images/file-uploader-icon.png"
//                       width="17px"
//                       alt=""
//                       className="snip-img"
//                     />
//                     <div className={`${css.sideNav_text} mt-2`}>
//                       Upload front Photo of your Aadhar Card.
//                     </div>
//                   </div>
//                 )}
//                 {frontLoaded && (
//                   <div className={css.uploaded}>
//                     <img
//                       src="/images/file-icon.png"
//                       width="26px"
//                       alt=""
//                       style={{ marginRight: '20px' }}
//                     />
//                     <div
//                       className="d-flex flex-column"
//                       style={{ width: '80%' }}
//                     >
//                       <div className={css.name}>{frontLoaded.name}</div>
//                       <div className={css.size}>
//                         {(frontLoaded.size / 1024 / 1024).toFixed(2)} MB
//                       </div>
//                     </div>
//                     <div className="image-block">
//                       <img
//                         src="/images/global-cross.png"
//                         width="10px"
//                         alt=""
//                         onClick={() => setfrontLoaded(null)}
//                       />
//                     </div>
//                   </div>
//                 )}
//               </div>
//               <div className={`${css.doc_upload} mt-4`}>
//                 <input
//                   id="backPhoto"
//                   name="backPhoto"
//                   type="file"
//                   accept="image/*"
//                   required
//                 />
//                 {!backLoaded && (
//                   <div className="cxy flex-column position-absolute ">
//                     <img
//                       src="/images/file-uploader-icon.png"
//                       width="17px"
//                       alt=""
//                       className="snip-img"
//                     />
//                     <div className={`${css.sideNav_text} mt-2`}>
//                       Upload back Photo of your Aadhar Card.
//                     </div>
//                   </div>
//                 )}
//                 {backLoaded && (
//                   <div className={css.uploaded}>
//                     <img
//                       src="/images/file-icon.png"
//                       width="26px"
//                       alt=""
//                       style={{ marginRight: '20px' }}
//                     />
//                     <div
//                       className="d-flex flex-column"
//                       style={{ width: '80%' }}
//                     >
//                       <div className={css.name}>{backLoaded.name}</div>
//                       <div className={css.size}>
//                         {(backLoaded.size / 1024 / 1024).toFixed(2)} MB
//                       </div>
//                     </div>
//                     <div className="image-block">
//                       <img
//                         src="/images/global-cross.png"
//                         width="10px"
//                         alt=""
//                         onClick={() => setbackLoaded(null)}
//                       />
//                     </div>
//                   </div>
//                 )}
//               </div>
//               {/* <div style={{ marginTop: "50px" }}>
//               <span style={{ color: "rgb(149, 149, 149)", fontWeight: 500 }}>
//                 State
//               </span>
//               <div className="kyc-input mt-2">
//                 <div className="kyc-input-text">Select State</div>
//                 <div className="arrow cxy">
//                   <img
//                     src="/images/global-black-chevronDown.png"
//                     width="15px"
//                     alt=""
//                   />
//                 </div>
//               </div>
//             </div> */}
//             </div>
//             <div  />
//             <div className="refer-footer p-0">
//               {/* <button className="refer-button btn-success mr-2  w-100 " style={{ background: '#6c757d !important' }}>
//               <a href="/kyc">Previous</a>
//             </button> */}
//               <button
//                 type="submit"
//                 className="w-100 btn-success bg-success"
//                 style={{
//                   border: 'none',
//                   borderRadius: '5px',
//                   fontSize: '1em',
//                   fontWeight: '700',
//                   height: '48px',
//                   color: '#fff',
//                   textTransform: 'uppercase',
//                 }}
//               >
//                 {/* <Link  >Next</Link> */}
//                 submit
//               </button>
//             </div>
//           </form>
//         </div>
//         {Boolean(process) && (
//           <div className="loaderReturn" style={{ zIndex: '99' }}>
//             <img
//               src={'/images/LandingPage_img/loader1.gif'}
//               style={{ width: '100%' }}
//             />
//           </div>
//         )}
//       </div>
//       <div className="rightContainer">
//         <Rightcontainer />
//       </div>
//     </div>
//   )
// }

// export default Kyc2


import React, { useEffect, useRef, useState } from 'react'
import Header from '../Components/Header'
import '../css/kyc.css'
import Rightcontainer from '../Components/Rightcontainer'
import { useHistory } from 'react-router-dom'
import axios from 'axios'
import Swal from 'sweetalert2'
import { MdCloudUpload, MdVerifiedUser, MdClose, MdEmail, MdPerson, MdCalendarToday, MdDialpad } from 'react-icons/md'

const Kyc2 = ({ user }) => {
  const history = useHistory()
  const [frontLoaded, setfrontLoaded] = useState(null)
  const [backLoaded, setbackLoaded] = useState(null)
  const [Name, setName] = useState('')
  const [Email, setEmail] = useState('')
  const [Number, setNumber] = useState('')
  const [DOB, setDob] = useState('')
  const [process, setProcess] = useState(false)
  let aadharProcess = useRef(false)

  // ✅ 2026 Premium Toast Configuration
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    background: '#1e1e1e',
    color: '#fff'
  });

  const handleSubmitdata = (e) => {
    e.preventDefault();
    if (user.verified === 'unverified' || user.verified === 'reject') {
      if (aadharProcess.current === false) {
        if (!frontLoaded || !backLoaded) {
          Toast.fire({ icon: 'warning', title: 'Please upload both sides of Aadhar' });
          return;
        }

        setProcess(true)
        aadharProcess.current = true
        const formData = new FormData()
        formData.append('Name', Name)
        formData.append('Email', Email)
        formData.append('Number', Number)
        formData.append('DOB', DOB)
        formData.append('front', frontLoaded)
        formData.append('back', backLoaded)

        const access_token = localStorage.getItem('token')
        const headers = { Authorization: `Bearer ${access_token}` }

        axios.post(`https://api.rrludo.in/aadharcard`, formData, { headers })
          .then((res) => {
            if (res.data.status === false || res.data.msg === false) {
              Toast.fire({ icon: 'error', title: res.data.msg || 'Duplicate Entity Found' });
            } else {
              Toast.fire({ icon: 'success', title: 'KYC Submitted Successfully' });
              history.push('/Profile')
            }
            aadharProcess.current = false
            setProcess(false)
          })
          .catch((e) => {
            setProcess(false);
            aadharProcess.current = false;
            if (e.response?.status === 401) {
              localStorage.removeItem('token');
              history.push('/login');
            } else {
              Toast.fire({ icon: 'error', title: 'Network Error!' });
            }
          })
      } else {
        Toast.fire({ icon: 'info', title: 'Request already in progress' });
      }
    } else {
      Toast.fire({ icon: 'info', title: 'Verification is already in process' });
    }
  }

  useEffect(() => {
    let access_token = localStorage.getItem('token')
    if (!access_token) history.push('/login');
  }, [history])

  // --- UI THEME STYLES ---
  const styles = {
    pageBg: {
      background: 'radial-gradient(circle at top, #1a1a1a, #0a0a0a)',
      minHeight: '100vh',
      paddingTop: '85px',
      color: '#fff',
      fontFamily: "'Inter', sans-serif"
    },
    kycCard: {
      background: 'rgba(30, 30, 30, 0.5)',
      backdropFilter: 'blur(15px)',
      borderRadius: '28px',
      border: '1px solid rgba(255,255,255,0.05)',
      padding: '30px 20px',
      marginBottom: '30px',
      boxShadow: '0 25px 50px rgba(0,0,0,0.5)'
    },
    inputGroup: {
      background: '#121212',
      borderRadius: '16px',
      border: '1px solid #333',
      display: 'flex',
      alignItems: 'center',
      padding: '12px 18px',
      marginBottom: '20px'
    },
    textInput: {
      background: 'transparent',
      border: 'none',
      color: '#fff',
      width: '100%',
      outline: 'none',
      fontSize: '15px',
      marginLeft: '12px'
    },
    uploadBox: {
      background: 'rgba(255,255,255,0.02)',
      border: '2px dashed #444',
      borderRadius: '18px',
      padding: '25px',
      textAlign: 'center',
      position: 'relative',
      cursor: 'pointer',
      transition: '0.3s'
    },
    submitBtn: {
      background: 'linear-gradient(180deg, #FF3131 0%, #BA0000 100%)',
      color: '#fff',
      border: 'none',
      borderRadius: '16px',
      padding: '18px',
      width: '100%',
      fontWeight: '800',
      fontSize: '16px',
      textTransform: 'uppercase',
      letterSpacing: '1px',
      boxShadow: '0 10px 25px rgba(186,0,0,0.3)',
      marginTop: '10px'
    }
  };

  return (
    <>
      <Header user={user} />
      <div style={styles.pageBg}>
        <div className='container Orher_page_main_section'>
          <div className='row justify-content-center'>
            <div className='col-lg-7 col-md-12'>
              
              <div className="text-center mb-4">
                 <MdVerifiedUser size={45} color="#FF3131" className="mb-2" />
                 <h3 className="fw-bold">Aadhar Verification</h3>
                 <p className="text-muted small">Enter your details as per Govt. ID</p>
              </div>

              <div style={styles.kycCard}>
                <form onSubmit={handleSubmitdata}>
                  {/* Full Name */}
                  <div style={styles.inputGroup}>
                    <MdPerson color="#FF3131" size={20} />
                    <input
                      style={styles.textInput}
                      placeholder="Full Name (As per Aadhar)"
                      value={Name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </div>

                  {/* Email */}
                  <div style={styles.inputGroup}>
                    <MdEmail color="#FF3131" size={20} />
                    <input
                      style={styles.textInput}
                      type="email"
                      placeholder="Email Address"
                      value={Email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  {/* DOB - Cross-device consistent picker */}
                  <div style={styles.inputGroup}>
                    <MdCalendarToday color="#FF3131" size={20} />
                    <input
                      style={styles.textInput}
                      type="date"
                      value={DOB}
                      onChange={(e) => setDob(e.target.value)}
                      required
                      className="custom-date-picker"
                    />
                  </div>

                  {/* Aadhar Number */}
                  <div style={styles.inputGroup}>
                    <MdDialpad color="#FF3131" size={20} />
                    <input
                      style={styles.textInput}
                      type="tel"
                      maxLength={12}
                      placeholder="12 Digit Aadhar Number"
                      value={Number}
                      onChange={(e) => setNumber(e.target.value.replace(/\D/g, ''))}
                      required
                    />
                  </div>

                  {/* Front Photo Upload */}
                  <div className="mb-4">
                    <label className="small text-muted mb-2 px-2">AADHAR FRONT SIDE</label>
                    <div style={styles.uploadBox} onClick={() => document.getElementById('frontPhoto').click()}>
                        <input id="frontPhoto" type="file" accept="image/*" className="d-none" onChange={(e) => setfrontLoaded(e.target.files[0])} />
                        {frontLoaded ? (
                            <div className="d-flex align-items-center justify-content-between">
                                <span className="text-truncate small">{frontLoaded.name}</span>
                                <MdClose color="#FF3131" size={20} onClick={(e) => { e.stopPropagation(); setfrontLoaded(null); }} />
                            </div>
                        ) : (
                            <div className="py-2">
                                <MdCloudUpload size={30} color="#666" />
                                <p className="small mb-0 text-muted mt-2">Tap to upload Front Side</p>
                            </div>
                        )}
                    </div>
                  </div>

                  {/* Back Photo Upload */}
                  <div className="mb-5">
                    <label className="small text-muted mb-2 px-2">AADHAR BACK SIDE</label>
                    <div style={styles.uploadBox} onClick={() => document.getElementById('backPhoto').click()}>
                        <input id="backPhoto" type="file" accept="image/*" className="d-none" onChange={(e) => setbackLoaded(e.target.files[0])} />
                        {backLoaded ? (
                            <div className="d-flex align-items-center justify-content-between">
                                <span className="text-truncate small">{backLoaded.name}</span>
                                <MdClose color="#FF3131" size={20} onClick={(e) => { e.stopPropagation(); setbackLoaded(null); }} />
                            </div>
                        ) : (
                            <div className="py-2">
                                <MdCloudUpload size={30} color="#666" />
                                <p className="small mb-0 text-muted mt-2">Tap to upload Back Side</p>
                            </div>
                        )}
                    </div>
                  </div>

                  <button type="submit" style={styles.submitBtn} disabled={process}>
                    {process ? 'PROCESSING...' : 'SUBMIT VERIFICATION'}
                  </button>
                </form>
              </div>

              <div className="text-center opacity-25 py-4">
                  <small style={{letterSpacing: '1px'}}>ENCRYPTED DOCUMENT STORAGE • SSL SECURE</small>
              </div>
            </div>

            <div className='col-lg-4 d-none d-lg-block'>
              <Rightcontainer />
            </div>
          </div>
        </div>
      </div>

      {/* Loading Overlay */}
      {process && (
        <div style={{position: 'fixed', top:0, left:0, width:'100%', height:'100%', background:'rgba(0,0,0,0.8)', zIndex: 9999, display:'flex', alignItems:'center', justifyContent:'center'}}>
            <img src="/images/LandingPage_img/loader1.gif" style={{width: '80px'}} alt="loading" />
        </div>
      )}

      <style>{`
        .custom-date-picker::-webkit-calendar-picker-indicator {
          filter: invert(1);
          cursor: pointer;
        }
        .uploadBox:hover { border-color: #FF3131 !important; background: rgba(255,49,49,0.02) !important; }
      `}</style>
    </>
  )
}

export default Kyc2